import { createContext, useState, useEffect } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({});

    useEffect(() => {
        const itemsData = JSON.parse(localStorage.getItem('NKUserProfileInfo'))
        const user = itemsData?.user
        const accessToken = itemsData?.accessToken;
        const refreshToken = itemsData?.refreshToken;
        const key = itemsData?.key;
        const email = itemsData?.email;
        setAuth({ user, key, accessToken, refreshToken, email});
    }, [])
    return (
        <AuthContext.Provider value={{ auth, setAuth }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext; 